import { render, staticRenderFns } from "./esg.vue?vue&type=template&id=3fc4de71&scoped=true"
import script from "./esg.vue?vue&type=script&lang=js"
export * from "./esg.vue?vue&type=script&lang=js"
import style0 from "./esg.vue?vue&type=style&index=0&id=3fc4de71&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4de71",
  null
  
)

export default component.exports